var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E37B54",
    d: "M11.524 3.082a.5.5 0 0 1 .952 0l1.518 4.673a1.5 1.5 0 0 0 1.427 1.037h4.914a.5.5 0 0 1 .294.904l-3.976 2.889a1.5 1.5 0 0 0-.545 1.677l1.519 4.674a.5.5 0 0 1-.77.559l-3.975-2.889a1.5 1.5 0 0 0-1.764 0l-3.975 2.889a.5.5 0 0 1-.77-.56l1.519-4.673a1.5 1.5 0 0 0-.545-1.677L3.37 9.696a.5.5 0 0 1 .294-.904h4.914a1.5 1.5 0 0 0 1.427-1.037l1.518-4.673Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty-star.8d02f5b607b2d0f2fc9af19ad931f406.svg";
export { ForwardRef as ReactComponent };